import { render } from "./AdminIndex.vue?vue&type=template&id=51229191&ts=true"
import script from "./AdminIndex.vue?vue&type=script&lang=ts"
export * from "./AdminIndex.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__